import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Facebook, ShieldCheck } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1E293B] text-white py-12 border-t-4 border-[#B91C1C] mt-auto">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-start mb-10">
          
          {/* 1. Identity & Tagline */}
          <div className="space-y-3 text-center lg:text-left">
            <h2 className="text-3xl font-black tracking-tight" style={{ fontFamily: 'Noto Serif Kannada, serif' }}>
              ಕಲ್ಲಿನ ಕೂಗು
            </h2>
            <p className="text-gray-400 text-xs italic font-kannada leading-relaxed">
              2016 ರಿಂದ ಚಿತ್ರದುರ್ಗ ಜಿಲ್ಲೆಯ ಜನರ ಧ್ವನಿಯಾಗಿ, <br /> 
              ನಿಷ್ಠಾಪಕ್ಷಪಾತ ಸುದ್ದಿ ನೀಡುತ್ತಿರುವ ನಿಮ್ಮ ನೆಚ್ಚಿನ ದಿನಪತ್ರಿಕೆ.
            </p>
            <div className="flex justify-center lg:justify-start gap-3 pt-1">
              <a href="https://www.facebook.com/kallinakooguhsd/" target="_blank" rel="noreferrer" className="p-2 bg-gray-800 rounded-lg hover:bg-[#B91C1C] transition-all">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="https://wa.me/917019362261" className="p-2 bg-gray-800 rounded-lg hover:bg-green-600 transition-all">
                <Phone className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* 2. Official Details (Trust Signals for Google) */}
          <div className="space-y-5 bg-[#0F172A] p-5 rounded-xl border border-gray-800 shadow-xl">
            <div>
              <h4 className="text-[9px] font-black text-[#B91C1C] uppercase tracking-[0.2em] mb-2">ಕಚೇರಿ ವಿಳಾಸ (Office)</h4>
              <div className="flex gap-2 text-xs text-gray-300 font-kannada leading-snug">
                <MapPin className="h-4 w-4 text-gray-500 shrink-0" />
                <p>ಶಿವಲಿಂಗಪ್ಪ ಲೇಔಟ್, ಹೊಸದುರ್ಗ, <br /> ಚಿತ್ರದುರ್ಗ ಜಿಲ್ಲೆ - 577527</p>
              </div>
            </div>
            
            <div className="pt-3 border-t border-gray-800">
              <h4 className="text-[9px] font-black text-[#B91C1C] uppercase tracking-[0.2em] mb-1">ಸಂಪಾದಕರು (Editor)</h4>
              <p className="text-base font-bold text-gray-100 font-kannada leading-none">ಪ್ರಕಾಶ್ ಮೂರ್ತಿ ಎಸ್</p>
              <p className="text-[10px] text-gray-400 font-kannada mt-1">(ಎಚ್ಚರಿಕೆ ಪ್ರಕಾಶ್ ಮೂರ್ತಿ)</p>
            </div>
          </div>

          {/* 3. Branding Box - Compact Size */}
          <div className="flex flex-col items-center lg:items-end justify-center h-full">
            <div className="relative py-3 px-5 border border-gray-800 rounded-lg bg-[#0F172A] shadow-md w-fit">
              <div className="text-center space-y-0.5">
                <p className="text-[8px] uppercase tracking-[0.15em] text-gray-500 font-bold">
                  Project Excellence
                </p>
                <div className="flex flex-col items-center justify-center">
                  <span className="text-gray-400 text-[9px]">Designed & Maintained by</span>
                  <span className="text-sm font-black text-[#B91C1C] tracking-tight">
                    Shivaprakash IT Solutions
                  </span>
                </div>
              </div>
              
              {/* Minimal Red Corner Accents */}
              <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-[#B91C1C] -mt-0.5 -ml-0.5 rounded-tl-sm"></div>
              <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-[#B91C1C] -mb-0.5 -mr-0.5 rounded-br-sm"></div>
            </div>
          </div>
        </div>

        {/* BOTTOM SECTION */}
        <div className="pt-6 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-wrap justify-center gap-5 text-[9px] font-black text-gray-500 uppercase tracking-widest">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/admin" className="flex items-center gap-1 hover:text-[#B91C1C] transition-colors">
              <ShieldCheck className="h-3 w-3" /> Management
            </Link>
          </div>
          <p className="text-[9px] text-gray-600 uppercase tracking-[0.1em]">
            &copy; {new Date().getFullYear()} Kallina Koogu. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
